import BottomIcon from "../assets/icons/BottomIcon.svg";
import MiddleBottomIcon from "../assets/icons/MiddleBottomIcon.svg";
import TopIcon from "../assets/icons/TopIcon.svg";
import TopMiddleBottomIcon from "../assets/icons/TopMiddleBottomIcon.svg";

export const ICONS: Record<string, string> = {
  MiddleBottomIcon,
  BottomIcon,
  TopMiddleBottomIcon,
  TopIcon,
};
